import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/repo/apps/klant/src/app/(auth)/wachtwoord-vergeten/forgot-password-form.tsx");
